import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SwiperDirective } from "./swiper.directive";

@NgModule({
    imports: [CommonModule, SwiperDirective],
    exports: [SwiperDirective],
})
export class SharedUiSwiperModule {}
